"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserErrorResponseSchema = exports.UserError = void 0;
const zod_1 = require("zod");
class UserError extends Error {
    constructor(message, statusCode, reason) {
        super(message);
        this.name = 'UserError';
        this.statusCode = statusCode;
        this.reason = reason;
    }
}
exports.UserError = UserError;
/** Error body returned on failure by endpoints that throw `UserError`. */
exports.UserErrorResponseSchema = zod_1.z.object({
    error: zod_1.z.string(),
    reason: zod_1.z.string().optional(),
});
//# sourceMappingURL=UserError.js.map